import _ from 'lodash';
import React, { useEffect, useContext, useRef } from 'react';
import CartContext from '../CartContext';
import { Link } from 'gatsby';
import log from 'loglevel';

const formatCurrency = (val) => _.toNumber(val).toFixed(2);

const formatPlantType = (PlantType) => {
  switch (PlantType) {
    case 'POT':
      return '3-inch pot';
    case 'PLUGTRAY':
      return 'plug tray';
    case 'COLLECTION':
      return 'collection';
    default:
      throw new Error(`invalid plant type ${PlantType}`);
  }
};

const CartBannerWidgetMarkup = () => {
  /*
  const { frontmatter } = componentText;
  const { Cart, WidgetVisible, SetWidgetVisible } = useContext(CartContext);
  const { PlugtrayCount, Subtotal, ProductsHydrated } = Cart;
  const wrapper = useRef(null);
  */

  const {
    Cart,
    WidgetVisible,
    SetWidgetVisible,
    Subtotal,
    PlugtrayCount,
    PotCount,
    CartProductsHydrated,
    GiftCards,
  } = useContext(CartContext.Context);
  log.debug({ Cart, CartProductsHydrated, GiftCards }, 'got data from cart!');
  const wrapper = useRef(null);

  const handleClick = () => SetWidgetVisible(!WidgetVisible);
  const handleClickOutside = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      SetWidgetVisible(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  const plugtraysInCart = _.filter(CartProductsHydrated, {
    PlantType: 'PLUGTRAY',
  });
  const potsInCart = _.reject(CartProductsHydrated, { PlantType: 'PLUGTRAY' });

  // eslint-disable-next-line
  const renderProduct = ({
    Id,
    CommonName,
    BotanicalName,
    Name,
    NamePlugtrays,
    Quantity,
    PlantType,
    UnitPrice,
  }) => (
    <li
      key={`${Id}-${PlantType}`}
      className={`minicart--product ${
        PlantType == 'PLUGTRAY'
          ? 'minicart--product__plugtray'
          : 'minicart--product__pot'
      } grid-x grid-padding-y`}
    >
      <p className="cell small-10">
        {BotanicalName && (
          <>
            <em>{BotanicalName}</em>
            <br />
          </>
        )}
        {CommonName || Name || NamePlugtrays} {formatPlantType(PlantType)}
      </p>
      <p className="minicart--product-quantity cell small-2">
        <strong>
          ${UnitPrice} <br />x{Quantity}
        </strong>
      </p>
    </li>
  );

  const renderGiftCard = ({ Id, RecipientName, Amount }, index) => (
    <li
      key={`${index}-giftcard`}
      className="minicart--product grid-x grid-padding-y"
    >
      <p className="cell small-10">Gift card for {RecipientName}</p>
      <p className="minicart--product-quantity cell small-2">
        <strong>${Amount}</strong>
      </p>
    </li>
  );

  return (
    <li key="cartWidget" ref={wrapper}>
      <a
        className={`menu toggle ${WidgetVisible ? 'open' : 'closed'}`}
        aria-controls="minicart"
        aria-expanded={`${WidgetVisible}`}
        onClick={handleClick}
      >
        <i className="fi-shopping-cart" /> Your Cart
      </a>
      <ul className="submenu" id="minicart">
        {!_.get(Cart, ['data', 'GetCart', 'Products']) ? (
          <p>Cart is empty!</p>
        ) : (
          <>
            {PlugtrayCount > 0 && (
              <li>
                <ul>
                  <h4 className="header__small-caps minicart--section-header">
                    Plug trays
                  </h4>
                  {/* {PlugtrayCount % 2 === 1 && (
                <p className="minicart--plugtray-count">
                  <strong>Tip: </strong>You have room in your order to add a plug tray without increasing your shipping costs!
                </p>
              )} */}
                  {_.map(plugtraysInCart, renderProduct)}
                </ul>
              </li>
            )}
            {potsInCart.length > 0 && (
              <li>
                <ul>
                  <h4 className="header__small-caps minicart--section-header">
                    Pots
                  </h4>
                  {_.map(potsInCart, renderProduct)}
                </ul>
              </li>
            )}
            {GiftCards && (
              <li>
                <ul>
                  <h4 className="header__small-caps minicart--section-header">
                    Gift cards
                  </h4>
                  {_.map(GiftCards, renderGiftCard)}
                </ul>
              </li>
            )}
            <li className="minicart--summary">
              <p className="minicart--subtotal">
                Subtotal <span>{formatCurrency(Subtotal)}</span>
              </p>
              <hr />

              <Link
                to="/app/cart"
                className="button secondary minicart--checkout-button"
              >
                View cart and check out
              </Link>
            </li>
          </>
        )}
      </ul>
    </li>
  );
};

export default CartBannerWidgetMarkup;
